import { functions } from "../firebase";

export type ZoomConnection = {
  connected: boolean;
  // Set when this community uses another community's Zoom account. That
  // account is not theirs, so email, displayName and scopes come back empty.
  sharedFrom?: string | null;
  email?: string;
  displayName?: string;
  scopes?: string[];
  stale?: boolean;
  staleReason?: string | null;
};

export const getZoomConnection = async (
  communityId: string
): Promise<ZoomConnection> => {
  const callable = functions.httpsCallable("zoomGetConnection");
  const result = await callable({ communityId });
  return result.data as ZoomConnection;
};

export const startZoomAuth = async (
  communityId: string
): Promise<{ url: string; expiresAt: string }> => {
  const callable = functions.httpsCallable("zoomStartAuth");
  const result = await callable({ communityId });
  return result.data as { url: string; expiresAt: string };
};

export const disconnectZoom = async (
  communityId: string
): Promise<{ connected: boolean }> => {
  const callable = functions.httpsCallable("zoomDisconnect");
  const result = await callable({ communityId });
  return result.data as { connected: boolean };
};
